import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import Team from '../Team/Team';
import './Teams.css';
import { TEAMS } from '../../../constants/teamNames';

const Teams = ({ selectedTeamName, onClickTeam }) => (
  <Box className="box-container">
    {TEAMS.map((team) => (
      <Team
        key={team.name}
        label={team.label}
        selected={team.name === selectedTeamName}
        onClickTeam={() => onClickTeam(team.name)}
      />
    ))}
  </Box>
);

Teams.propTypes = {
  selectedTeamName: PropTypes.string.isRequired,
  onClickTeam: PropTypes.func.isRequired,
};

export default Teams;
